import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { convertNameFormat } from '../../utils/Common';
export default function BannerGameImages({ img, index }) {
    console.log(img, "imggggggggggg")
    const [imageLoaded, setImageLoaded] = useState(false);
    const isFirst = index === 0;
    const imgElement = (
        <img
            src={img.src}
            alt={img.description}
            onLoad={() => setImageLoaded(true)}
            onError={() => console.log("error loading")}
        />
    )
    return (
        <>
            <div className={imageLoaded ? "" : "hide-visibility"}>
                {isFirst ? (imgElement) : (
                    <Link
                        // to={img?.game?.game_level_id ? `/games/subject-${img.game.game_level_id}` : '#'}
                        to={img?.game_level_id ? `/games/${convertNameFormat(img?.gamelevel_name)}` : '#'}
                        onClick={(e) => {
                            if (!img?.game_level_id) {
                                e.preventDefault();
                            } else {
                                window.scrollTo(0, 0);
                            }
                        }}
                        style={{ cursor: img?.game_level_id ? "pointer" : "default" }}
                    >
                        {/* <div className="banner-actions-container">
                        <div className="banner-desc">{img.description}</div>
                        <button className="banner-play-button">Play Now</button>
                    </div> */}
                        {imgElement}
                    </Link>
                )}
            </div>
            <div
                className={imageLoaded ? "hide-visibility" : "sample-banner"}
            ></div>
        </>
    )
}
